module.exports = __webpack_public_path__ + "static/img/third6.683cceb7.png";